module.exports = __webpack_public_path__ + "img/coronagirlar.1112aa8f.svg";